export default __webpack_public_path__ + "static/media/stars-bg-mobile.d9fc98d0.png";